/**
 * Imports all the modules that matches
 * the name of the organism
 * @param {string} name
 * @param {function} loader
 */
function importModule(name, loader) {
  const elements = document.querySelectorAll(`[data-cmp-is="${name}"]`)
  if (elements.length === 0) return window.Promise.resolve()


  if (loader) {
    return loader()
      .then((module) => ({
        module: module.default,
        elements
      }))
      .catch((err) =>
        window.Promise.reject(
          new Error(`There was an error loading your JS file - ${err}`)
        )
      )
  }
  return window.Promise.reject(`There is no loader for ${name}`)
}
/**
 * Creates instances for all the modules that
 * are passed in the array
 * @param {{name: string, loader: Function}[]} modules
 * @returns {Promise}
 */
export function create(modules) {
  const isLoadedAttr = 'data-cmp-is-loaded'
  return window.Promise.all(
    modules.map(async (item) => {
      const data = await importModule(item.name, item.loader)
      const items = []

      if (data) {
        const { module: Module, elements } = data

        Array.from(elements).forEach(($target) => {
          if ($target.getAttribute(isLoadedAttr) === 'true') return

          $target.setAttribute(isLoadedAttr, true)
          items.push(new Module($target))
        })
      }

      return items
    })
  )
}
